import { BrowserRouter, Routes, Route } from "react-router-dom";
import { useState, useEffect } from "react";
import { Context } from "./Helper/Context";
import './App.css';
import GeneralContainerWrapper, { AdminContainerWrapper } from "./global/GeneralContainer"
import Feed from "./Component/Feed/Feed"
import MyArticles from "./Component/Articles/myArticles";
import Articlesfav from "./Component/Home/articlesfav";
import ArticlesFavByReview from "./Component/Home/articlesfavbyreview";
import Friends from "./Component/Friend/Friends";
import UserProfile from "./Component/Profile/UserProfile";
import Followed from "./Component/Suivis/suivis";
import FriendsMessages from "./Component/Listmsg/Listmsg";
import Profile from "./Component/Profile/Profile";
import ProfileEdit from "./Component/Profile/Edit";
import Articles from "./Component/Home/articles"
import Article from "./Component/Review/Article"
import Login from "./Component/Login/Login"
import WhatThisCountryTalkAbout from "./Component/Home/WhatThisCountryTalkAbout";
import TheCountrySpeaksOf from "./Component/Home/TheCountrySpeaksOf";
import WhichCountriesSpeakAbout from "./Component/Home/WhichCountriesSpeakAbout";
import Subscription from "./Component/Subscription/Subscription";
import Map from './Component/Map/Map'
import Review from './Component/Review/Review'
import EditReview from './Component/Review/EditReview'
import AddToReview from './Component/Review/AddToReview'
import AddToFriendReview from "./Component/Review/AddToFriendReview";
import { HelmetProvider } from 'react-helmet-async';
import { clearSession, ensureTokenKey, redirectToLogin } from "./HTTP/session";
import Admin from "./Component/Admin/Admin";
import UserAdmin from "./Component/Admin/UserAdmin";
import EditUser from "./Component/Admin/EditUser";
import AddUser from "./Component/Admin/AddUser";
import AddManyUser from "./Component/Admin/AddManyUser";
import MyArticlesCreate from "./Component/Articles/myArticlesCreate";
import MyArticlesEdit from "./Component/Articles/myArticlesEdit";
import ArticlesAdmin from "./Component/Admin/ArticlesAdmin";
import FeedModerationAdmin from "./Component/Admin/FeedModerationAdmin";
import Notifications from "./Component/Home/notifications";
import CheckArticle from "./Component/Admin/checkArticle";
import UserSubscription from "./Component/Subscription/userSubscription";
import AdminSubscription from "./Component/Admin/SubscriptionAdmin";
import AddSubscription from "./Component/Admin/AddSubscription";
import EditSubscription from "./Component/Admin/EditSubscription";
import AdminPriceSubscription from "./Component/Admin/PriceSubscriptionAdmin";
import AiTokenPricesAdmin from "./Component/Admin/AiTokenPricesAdmin";
import AddPriceSubscription from "./Component/Admin/AddPriceSubscription";
import EditPriceSubscription from "./Component/Admin/EditPriceSubscription";
import OptionsAdmin from "./Component/Admin/OptionsAdmin";
import PaymentsAdmin from "./Component/Admin/PaymentsAdmin";
import { CheckoutForm } from "./Component/Subscription/PaymentForm";
import NextPagePayment from "./Component/Subscription/NextPagePayment";
import EditKeyword from "./Component/Suivis/editKeyword";
import AddKeyword from "./Component/Suivis/addKeyword";
import ResetPassword from "./Component/Login/ResetPassword";
import { Reviews } from "./Component/Review/Reviews";
import { CseAdmin } from "./Component/Admin/CseAdmin";
import AddCse from "./Component/Admin/AddCse";
import ThematicsTreeAdmin from "./Component/Admin/ThematicsTreeAdmin";
import EditCse from "./Component/Admin/EditCse";
import { IgoAdmin } from "./Component/Admin/IgoAdmin";
import EditIgo from "./Component/Admin/EditIgo";
import AddIgo from "./Component/Admin/AddIgo";
import RegionsAdmin from "./Component/Admin/RegionsAdmin";
import RegionForm from "./Component/Admin/RegionForm";
import { LinksThematicAdmin } from "./Component/Admin/LinksThematicAdmin";
import AddLinksThematic from "./Component/Admin/AddLinksThematic";
import EditLinksThematic from "./Component/Admin/EditLinksThematic";
import Igo from "./Component/Home/igo";
import IgoPresentation from "./Component/Home/IgoPresentation";
import RegionsPresentation from "./Component/Home/RegionsPresentation";
import BeneficiaryManagement from "./Component/Subscription/BeneficiaryManagement";
import Conditions from "./Component/CONDITIONS/Conditions"
import Legales from "./Component/CONDITIONS/Legales";
import POLITIQUE from "./Component/CONDITIONS/POLITIQUE";
import { About } from "./Component/CONDITIONS/about";
import ReviewAdmin from "./Component/Admin/ReviewAdmin";
import CheckReview from "./Component/Admin/checkReview";
import { IgoThemesAdmin } from "./Component/Admin/IgoThemesAdmin";
import AddIgoTheme from "./Component/Admin/AddIgoTheme";
import EditIgoTheme from "./Component/Admin/EditIgoTheme";
import ZemusIa from "./Component/Home/zemusIa";
import TutorialAdmin from "./Component/Admin/TutorialAdmin";
import HomeHub from "./Component/Home/HomeHub";
import CountryPurchase from "./Component/Subscription/CountryPurchase";
import AiTokenPurchase from "./Component/Subscription/AiTokenPurchase";
import ZemusPlans from "./Component/Home/ZemusPlans";

let W_MYARTICLES = GeneralContainerWrapper(MyArticles)
let W_MYARTICLESCREATE = GeneralContainerWrapper(MyArticlesCreate)
let W_MYARTICLESEDIT = GeneralContainerWrapper(MyArticlesEdit)
let W_ARTICLECHECK = AdminContainerWrapper(CheckArticle)
let W_ARTICLES = GeneralContainerWrapper(Articles)
let W_ARTICLES_FAV = GeneralContainerWrapper(Articlesfav)
let W_ARTICLES_FAV_BY_REVIEW = GeneralContainerWrapper(ArticlesFavByReview)
let W_ARTICLE = GeneralContainerWrapper(Article)
let W_WHAT_THIS_COUNTRY_TALK_ABOUT = GeneralContainerWrapper(WhatThisCountryTalkAbout)
let W_THE_COUNTRY_SPEAKS_OF = GeneralContainerWrapper(TheCountrySpeaksOf)
let W_WHICH_COUNTRIES_SPEAK_ABOUT = GeneralContainerWrapper(WhichCountriesSpeakAbout)
let W_FEED = GeneralContainerWrapper(Feed)
let W_FRIENDS = GeneralContainerWrapper(Friends)
let W_FRIEND_PROFILE = GeneralContainerWrapper(UserProfile)
let W_FRIENDS_MESSAGES = GeneralContainerWrapper(FriendsMessages)
let W_PROFILE = GeneralContainerWrapper(Profile)
let W_EDIT = GeneralContainerWrapper(ProfileEdit)
let W_FOLLOWED = GeneralContainerWrapper(Followed)
let W_MAP = GeneralContainerWrapper(Map)
let W_REVIEW = GeneralContainerWrapper(Review)
let W_ADDTOREVIEW = GeneralContainerWrapper(AddToReview)
let W_ADDTOFRIENDREVIEW = GeneralContainerWrapper(AddToFriendReview)
let W_EDITREVIEW = GeneralContainerWrapper(EditReview)
let W_ADMIN = AdminContainerWrapper(Admin)
let W_USERADMIN = AdminContainerWrapper(UserAdmin)
let W_EDITUSERADMIN = AdminContainerWrapper(EditUser)
let W_ADDUSERADMIN = AdminContainerWrapper(AddUser)
let W_ADDMANYUSERADMIN = AdminContainerWrapper(AddManyUser)
let W_ARTICLESADMIN = AdminContainerWrapper(ArticlesAdmin)
let W_FEEDMODERATIONADMIN = AdminContainerWrapper(FeedModerationAdmin)
let W_NOTIFICATIONS = GeneralContainerWrapper(Notifications)
let W_ADMINSUBSCRIPTION = AdminContainerWrapper(AdminSubscription)
let W_ADMINADDSUBSCRIPTION = AdminContainerWrapper(AddSubscription)
let W_ADMINEDITSUBSCRIPTION = AdminContainerWrapper(EditSubscription)
let W_ADMINPRICESUBSCRIPTION = AdminContainerWrapper(AdminPriceSubscription)
let W_ADMINADDPRICESUBSCRIPTION = AdminContainerWrapper(AddPriceSubscription)
let W_ADMINEDITPRICESUBSCRIPTION = AdminContainerWrapper(EditPriceSubscription)
let W_ADMINAITOKENPRICES = AdminContainerWrapper(AiTokenPricesAdmin)
let W_ADMINOPTIONS = AdminContainerWrapper(OptionsAdmin)
let W_ADMINPAYMENTS = AdminContainerWrapper(PaymentsAdmin)
let W_PAYSUBSCRIPTION = GeneralContainerWrapper(CheckoutForm)
let W_NEXTPAGEPOSTPAYMENT = GeneralContainerWrapper(NextPagePayment)
let W_USER_SUBSCRIPTION = GeneralContainerWrapper(UserSubscription)
let W_ADDKEYWORDS = GeneralContainerWrapper(AddKeyword)
let W_EDITKEYWORDS = GeneralContainerWrapper(EditKeyword)
let W_REVIEWS = GeneralContainerWrapper(Reviews)
let W_CSEADMIN = AdminContainerWrapper(CseAdmin)
let W_ADDCSEADMIN = AdminContainerWrapper(AddCse)
let W_THEMATICSTREEADMIN = AdminContainerWrapper(ThematicsTreeAdmin)
let W_EDITCSEADMIN = AdminContainerWrapper(EditCse)
let W_IGOADMIN = AdminContainerWrapper(IgoAdmin)
let W_EDITIGOADMIN = AdminContainerWrapper(EditIgo)
let W_ADDIGOADMIN = AdminContainerWrapper(AddIgo)
let W_REGIONSADMIN = AdminContainerWrapper(RegionsAdmin)
let W_REGIONFORM = AdminContainerWrapper(RegionForm)
let W_ADMINLINKSTHMATICS = AdminContainerWrapper(LinksThematicAdmin)
let W_ADMINADDLINKSTHMATICS = AdminContainerWrapper(AddLinksThematic)
let W_ADMINEDITLINKSTHMATICS = AdminContainerWrapper(EditLinksThematic)
let W_IGO = GeneralContainerWrapper(Igo)
let W_IGO_PRESENTATION = GeneralContainerWrapper(IgoPresentation)
let W_REGIONS_PRESENTATION = GeneralContainerWrapper(RegionsPresentation)
let W_SUBSCIPTIONBENEFICIARIES = GeneralContainerWrapper(BeneficiaryManagement)
let W_CONDITIONS = GeneralContainerWrapper(Conditions)
let W_LEGALES = GeneralContainerWrapper(Legales)
let W_POLITIQUE = GeneralContainerWrapper(POLITIQUE)
let W_REVIEWSADMIN = AdminContainerWrapper(ReviewAdmin);
let W_REVIEWCHECK = AdminContainerWrapper(CheckReview);
let W_IGOTHEMEADMIN = AdminContainerWrapper(IgoThemesAdmin);
let W_ADDIGOTHEMEADMIN = AdminContainerWrapper(AddIgoTheme);
let W_EDITIGOTHEMEADMIN = AdminContainerWrapper(EditIgoTheme);
let W_ZEMUS_IA = GeneralContainerWrapper(ZemusIa)
let W_TUTORIALADMIN = AdminContainerWrapper(TutorialAdmin)
let W_HOME_HUB = GeneralContainerWrapper(HomeHub)
let W_COUNTRY_PURCHASE = GeneralContainerWrapper(CountryPurchase)
let W_ZEMUS_PLANS = GeneralContainerWrapper(ZemusPlans)
let W_AI_TOKEN_PURCHASE = GeneralContainerWrapper(AiTokenPurchase)


function App() {
  const [Fil, SetFil] = useState("fil");
  const [selection, setselection] = useState(false);
  const [publicationID, setPublicationID] = useState(false);
  const [friendAction, setFriendAction] = useState(false)

  ensureTokenKey()

  useEffect(() => {
      document.title = "Zemus - Locate the news"
  }, [])


  // Remplace ces 2 blocs "if (... window.location.href ...)" par :
const path = window.location.pathname;       // ex: "/login"

const isLoggedIn = !!(localStorage.getItem("token") && localStorage.getItem("token_age"));
const isLoginLike = path === "/login";
const isReset = path === "/resetpassword";
const isReviews = path.startsWith("/reviews");

if (!isReset && !isReviews && !isLoginLike && !isLoggedIn) {
  redirectToLogin();
}

if (localStorage.getItem("token_age")
  && (Date.now() - parseInt(localStorage.getItem("token_age"), 10) > 28800000)) {
  clearSession();
  // Ne “nettoie” pas la query si on est déjà sur /login avec des paramètres
  if (!isLoginLike) {
    redirectToLogin();
  }
}
  return (
    <HelmetProvider>
      <Context.Provider
        value={{
          Fil,
          SetFil,
          selection,
          setselection,
          publicationID,
          setPublicationID,
          friendAction,
          setFriendAction
        }}
      >

          <div className="App">
          <BrowserRouter>
              <Routes>
                <Route path="/" element={<W_HOME_HUB />}></Route>
                <Route path="/test-accueil" element={<W_HOME_HUB />}></Route>
                <Route path="/login" element={<Login />}></Route>
                <Route path="/resetpassword" element={<ResetPassword />}></Route>
                <Route path="/admin" element={<W_ADMIN />}></Route>
                <Route path="/admin/options" element={<W_ADMINOPTIONS />}></Route>
                <Route path="/admin/tutorials" element={<W_TUTORIALADMIN />}></Route>
                <Route path="/admin/users" element={<W_USERADMIN />}></Route>
                <Route path="/admin/users/add" element={<W_ADDUSERADMIN />}></Route>
                <Route path="/admin/users/add-many" element={<W_ADDMANYUSERADMIN />}></Route>
                <Route path="/admin/users/edit/:id" element={<W_EDITUSERADMIN />}></Route>
                <Route path="/admin/articles" element={<W_ARTICLESADMIN />}></Route>
                <Route path="/admin/feed/moderation" element={<W_FEEDMODERATIONADMIN />}></Route>
                <Route path="/admin/articles/check/:id" element={<W_ARTICLECHECK />}></Route>
                <Route path="/admin/reviews" element={<W_REVIEWSADMIN />}></Route>
                <Route path="/admin/reviews/check/:id" element={<W_REVIEWCHECK />}></Route>
                <Route path="/admin/subscription" element={ <W_ADMINSUBSCRIPTION /> }> </Route>
                <Route path="/admin/subscription/add" element={ <W_ADMINADDSUBSCRIPTION /> }> </Route>
                <Route path="/admin/subscription/edit/:id" element={ <W_ADMINEDITSUBSCRIPTION /> }> </Route>
                <Route path="/admin/subscription/prices" element={ <W_ADMINPRICESUBSCRIPTION /> }> </Route>
                <Route path="/admin/subscription/prices/add" element={ <W_ADMINADDPRICESUBSCRIPTION /> }> </Route>
                <Route path="/admin/subscription/prices/edit/:id" element={ <W_ADMINEDITPRICESUBSCRIPTION /> }> </Route>
                <Route path="/admin/ai-token-prices" element={ <W_ADMINAITOKENPRICES /> }> </Route>
                <Route path="/admin/subscription/payments" element={ <W_ADMINPAYMENTS /> }> </Route>
                <Route path="/admin/cse" element={ <W_CSEADMIN /> }> </Route>
                <Route path="/admin/cse/add" element={ <W_ADDCSEADMIN /> }> </Route>
                <Route path="/admin/thematics-tree" element={ <W_THEMATICSTREEADMIN /> }> </Route>
                <Route path="/admin/cse/edit/:id" element={ <W_EDITCSEADMIN /> }> </Route>
                <Route path="/admin/igo" element={ <W_IGOADMIN /> }> </Route>
                <Route path="/admin/igo/edit/:id" element={ <W_EDITIGOADMIN /> }> </Route>
                <Route path="/admin/igo/add" element={ <W_ADDIGOADMIN /> }> </Route>
                <Route path="/admin/regions" element={ <W_REGIONSADMIN /> }></Route>
                <Route path="/admin/regions/add" element={ <W_REGIONFORM /> }></Route>
                <Route path="/admin/regions/edit/:id" element={ <W_REGIONFORM /> }></Route>
                <Route path="/admin/igo-theme" element={ <W_IGOTHEMEADMIN /> }> </Route>
                <Route path="/admin/igo-theme/add" element={ <W_ADDIGOTHEMEADMIN /> }> </Route>
                <Route path="/admin/igo-theme/edit/:id" element={ <W_EDITIGOTHEMEADMIN /> }> </Route>
                <Route path="/admin/linksthematics" element={ <W_ADMINLINKSTHMATICS /> }> </Route>
                <Route path="/admin/linksthematics/add" element={ <W_ADMINADDLINKSTHMATICS /> }> </Route>
                <Route path="/admin/linksthematics/edit/:id" element={ <W_ADMINEDITLINKSTHMATICS /> }> </Route>
                <Route path="/:countrycode/what-this-country-talk-about" element={ <W_WHAT_THIS_COUNTRY_TALK_ABOUT/> }> </Route>
                <Route path="/:countrycode/the-country-speaks-of" element={ <W_THE_COUNTRY_SPEAKS_OF/> }> </Route>
                <Route path="/:countrycode/which-countries-speak-about" element={ <W_WHICH_COUNTRIES_SPEAK_ABOUT/> }> </Route>
                <Route path="/search" element={ <W_WHAT_THIS_COUNTRY_TALK_ABOUT/> }> </Route>
                <Route path="/articles" element={ <W_ARTICLES /> }> </Route>
                <Route path="/articles/:articleid" element={ <W_ARTICLE /> }> </Route>
                <Route path="/myarticles" element={ <W_MYARTICLES /> }> </Route>
                <Route path="/myarticles/create" element={ <W_MYARTICLESCREATE /> }> </Route>
                <Route path="/myarticles/edit/:id" element={ <W_MYARTICLESEDIT /> }> </Route>
                <Route path="/notifications" element= { <W_NOTIFICATIONS /> }></Route>
                <Route path="/feed" element={ <W_FEED/> }> </Route>
                <Route path="/favourites" element={ <W_ARTICLES_FAV/> }> </Route> 
                <Route path="/friends" element={ <W_FRIENDS/> }> </Route>
                <Route path="/friends/:id" element={ <W_FRIEND_PROFILE/> }> </Route>
                <Route path="/followed" element={ <W_FOLLOWED/> }> </Route>
                <Route path="/editkeywords/:id" element={ <W_EDITKEYWORDS /> }> </Route>
                <Route path="/addkeywords" element={ <W_ADDKEYWORDS /> }> </Route>
                <Route path="/friends-msg" element={ <W_FRIENDS_MESSAGES/> }> </Route>
                <Route path="/profile" element={ <W_PROFILE/> }> </Route>
                <Route path="/profile/subscription" element={ <W_USER_SUBSCRIPTION /> }> </Route>
                <Route path="/edit" element={ <W_EDIT/> }> </Route>
                <Route path="/Subscription" element={<Subscription />}></Route>
                <Route path="/addsubscription" element={<W_PAYSUBSCRIPTION />}></Route>
                <Route path="/zemus-plans" element={<W_ZEMUS_PLANS />}></Route>
                <Route path="/purchase-countries" element={<W_COUNTRY_PURCHASE />}></Route>
                <Route path="/ai-tokens" element={<W_AI_TOKEN_PURCHASE />}></Route>
                <Route path="/nextpagepayment" element={<W_NEXTPAGEPOSTPAYMENT />}></Route>
                <Route path="/subscription/beneficiary" element={<W_SUBSCIPTIONBENEFICIARIES />}></Route>
                <Route path="/map" element={<W_MAP />}></Route>
                <Route path="/mypublications" element={<W_REVIEWS />}></Route>
                <Route path="/reviews/:reviewid" element={<W_REVIEW />}></Route>
                <Route path="/reviews/:reviewid/addfavourites" element={<W_ARTICLES_FAV_BY_REVIEW />}></Route>
                <Route path="/addtoreview" element={<W_ADDTOREVIEW />}></Route> 
                <Route path="/addtofriendreview" element={<W_ADDTOFRIENDREVIEW />}></Route>
                <Route path="/editreviews/:reviewid" element={<W_EDITREVIEW />}></Route>
                <Route path="/igo" element={<W_IGO />}></Route>
                <Route path="/igo/:igoId" element={<W_IGO_PRESENTATION />}></Route>
                <Route path="/regionspresentation" element={<W_REGIONS_PRESENTATION />}></Route>
                <Route path="/zemus-ia" element={<W_ZEMUS_IA />}></Route>
                <Route path="/conditions" element={<W_CONDITIONS />}></Route>
                <Route path="/legales" element={<W_LEGALES />}></Route>
                <Route path="/politique" element={<W_POLITIQUE />}></Route>
                <Route path="/about" element={<About />}></Route>
              </Routes>
            </BrowserRouter>
          </div>

    </Context.Provider>
    </HelmetProvider>
  );
}

export default App;
